import React from 'react';

const ContentSections = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-[1010px]">
      {/* Today's offers */}
      <section className="mb-12">
        <h2 className="text-3xl font-normal text-[#00467f] mb-8">Today's offers</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <OfferCard
            href="https://www.aadvantagecruises.com/promotion/sweepstakes.do?reportedLocation=HomePageB1&reportedTitle=&_locale=en_US&utm_medium=banner&utm_source=aa-partner_site&utm_campaign=20250811-bspot&utm_content=sweeps#"
            image="/content/images/homepage/hero/en_US/b1-cruises-08182025.jpg"
            title="Million Miles Giveaway"
            body="Enter for a chance to win AAdvantage® miles and a cruise to Alaska"
            cta="Enter by October 10"
            external
          />
          <OfferCard
            href="https://www.aadvantageevents.com?reportedLocation=HomePageB2&reportedTitle=&_locale=en_US&_uid=f1115e9a-fb2a-4505-83c8-d757ee2a873a&utm_source=AA_Homepage&utm_medium=Homepage_B2#"
            image="/content/images/homepage/hero/en_US/b2-aadvantage-events-08182025.jpg"
            title="Your gameday starts here"
            body="Buy AAdvantage Events™ tickets and earn miles every time you cheer from the stands"
            cta="Find tickets today"
            external
          />
          <OfferCard
            href="https://www.aavacations.com/en/wellness-getaways/?reportedLocation=HomePageB3&reportedTitle=&_locale=en_US&c=DSP|20250811|MKT|AAV|LNK|MVS|AAV_AWAR_bspot_aug#"
            image="/content/images/homepage/hero/en_US/b3-aavacations-08182025.jpg"
            title="Relax and rejuvenate"
            body="Save up to $150 on an American Airlines Vacations℠ package"
            cta="Plan your escape today"
            external
          />
        </div>
      </section>

      {/* Divider between sections */}
      <div className="mx-4 mb-10">
        <img src="/content/images/homepage/hero/en_US/shadow-down.png" alt="" className="w-full block" />
      </div>

      {/* News and offers / Save on miles / Earn 80,000 bonus miles */}
      <section>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <NewsAndOffers />
          <SaveOnMiles />
          <EarnBonusMiles />
        </div>
      </section>
    </div>
  );
};

const OfferCard = ({ href, image, title, body, cta, external }) => {
  return (
    <div className="span4 feature">
      <a href={href} target={external ? "_blank" : "_self"} rel={external ? "noreferrer" : undefined} className="block">
        <img src={image} alt="" className="w-full h-48 object-cover" />
        <h3 className="text-lg font-normal text-[#627a88] mt-4">{title}</h3>
      </a>
      <a href={href} target={external ? "_blank" : "_self"} rel={external ? "noreferrer" : undefined}>
        <p className="feature-body text-gray-600 text-sm mt-2">{body}</p>
        <p className="feature-call text-[#0078d2] text-sm font-medium flex items-center mt-1">
          {cta}
          {external && (
            <>
              <span className="ml-1 text-xs" aria-hidden="true">↗</span>
              <span className="sr-only">Opens another site in a new window that may not meet accessibility guidelines</span>
            </>
          )}
        </p>
      </a>
    </div>
  );
};

const NewsAndOffers = () => {
  const links = [
    {
      text: "Have travel credit? Here's how to book",
      href: "/i18n/customer-service/payment-options/travel-credit.jsp?reportedLocation=homePage.do&reportedPosition=1&reportedTitle=Have+travel+credit%3f+Here's+how+to+book&repositoryName=PromotionContentRepository&repositoryId=&locale=en_US#",
      external: false,
    },
    {
      text: "Earn bonus miles glamping at Under Canvas",
      href: "https://world.hyatt.com/content/gp/en/offers/under-canvas-american-airlines.html?reportedLocation=homePage.do&reportedPosition=2&reportedTitle=Earn+bonus+miles+glamping+at+Under+Canvas&repositoryName=PromotionContentRepository&repositoryId=&locale=en_US#",
      external: true,
    },
  ];

  return (
    <div className="span4 feature">
      <h2 className="gamma text-[#627a88] text-xl font-normal mb-4">News and offers</h2>
      <ul className="list-standard">
        {links.map((link, index) => (
          <li key={index} className="mb-1">
            <a
              href={link.href}
              target={link.external ? "_blank" : "_self"}
              rel={link.external ? "noreferrer" : undefined}
              className="text-[#0078d2] hover:underline text-sm"
            >
              {link.text}
              {link.external ? (
                <span className="ml-1 text-xs" aria-hidden="true">↗</span>
              ) : (
                <span className="ml-1 call-to-action" />
              )}
            </a>
          </li>
        ))}
      </ul>
      <a className="feature-call call-to-action inline-flex items-center mt-3 text-[#0078d2]" href="/i18n/aadvantage-program/earn-miles/offers-promotions.html">
        <span className="icon icon-12 icon-promotion mr-1" aria-hidden="true"></span>
        Offers from our partners
      </a>
    </div>
  );
};

const SaveOnMiles = () => {
  return (
    <div className="span4 feature">
      <h3 className="text-xl font-normal text-[#627a88] mb-4">Save on miles</h3>
      <div className="grid grid-cols-2 gap-4 items-start">
        <img src="/content/images/homepage/hero/en_US/a1-bgt-07012025.jpg" alt="" className="w-full h-24 object-cover" />
        <div>
          <a
            href="https://www.aa.com/aadvantage-program/buy-gift-transfer/en_US/home/buy?cint=DSP||20240101|MKT|USMCOC|ASP||US_LYLTY_TRAN_BGT"
            target="_blank"
            rel="noreferrer"
          >
            <p className="feature-body text-gray-600 text-sm">Buy or gift miles and save up to 40% for a limited time</p>
            <p className="feature-call text-[#0078d2]">View your offer
              <span className="ml-1 text-xs" aria-hidden="true">↗</span>
              <span className="sr-only">Opens another site in a new window that may not meet accessibility guidelines.</span>
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

const EarnBonusMiles = () => {
  return (
    <div className="span4 feature">
      <h3 className="text-xl font-normal text-[#627a88] mb-4">Earn 80,000 bonus miles</h3>
      <div className="grid grid-cols-2 gap-4 items-start">
        <img src="/content/images/homepage/hero/en_US/a2-citi-ecm-platinum-select-card-2024.jpg" alt="Citi / AAdvantage credit card" className="w-full h-24 object-cover" />
        <div>
          <a
            href="https://creditcards.aa.com/citi-platinum-card-american-airlines-direct/?utm_medium=referral&utm_source=aa&utm_campaign=a2"
            target="_blank"
            rel="noreferrer"
          >
            <p className="feature-body text-gray-600 text-sm">Don't miss our summer special. Terms apply.</p>
            <p className="feature-call text-[#0078d2]">Learn more
              <span className="ml-1 text-xs" aria-hidden="true">↗</span>
              <span className="sr-only">Opens another site in a new window that may not meet accessibility guidelines</span>
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContentSections;
